import { createRouter, createWebHistory } from 'vue-router';
import { wenVisit } from '@/api/visit';
import { checkAdminAccess } from '@/utils/auth';

const routes = [
  {
    path: '/',
    name: 'View',
    component: () => import(/* webpackChunkName: "View" */ '../views/View.vue')
  },
  {
    path: '/Ecomall',
    name: 'EcoMall',
    component: () => import('@/views/EcoMall.vue')
  },
  {
    path: '/story',
    name: 'BrandStory',
    component: () => import('@/views/BrandStory.vue')
  },
  {
    path: '/Products',
    name: 'ProductIntro',
    component: () => import('@/views/ProductIntro.vue')
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import('@/views/Gallery.vue')
  },
  {
    path: '/team',
    name: 'TeamView',
    component: () => import('@/views/Team.vue')
  },
  {
    path: '/funding',
    name: 'FundingPlan',
    component: () => import('@/views/funding.vue')
  },
  {
    path: '/tbook',
    name: 'TBookView',
    component: () => import('@/views/tbook.vue')
  },
  {
    path: '/notes',
    name: 'Notes',
    component: () => import('@/views/Notes.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/visit',
    name: 'Visit',
    component: () => import('../views/visit.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/invite',
    name: 'Invite',
    component: () => import('@/views/Invite.vue')
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('@/views/Auth.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'AdminPanel',
    component: () => import('@/views/Admin.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // 添加404页面
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/EcoMall.vue') // 重定向到首页
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（比如浏览器前进后退），使用保存的位置
    if (savedPosition) {
      return savedPosition;
    }
    // 否则总是滚动到页面顶部
    return { top: 0, behavior: 'smooth' };
  }
});

// 全局前置守卫 - 优化版本
router.beforeEach(async (to, from, next) => {
  // 检查是否需要登录
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('token');
    if (!token) {
      console.log('路由守卫：需要登录，跳转到登录页面');
      next('/auth');
      return;
    }
  }

  // 检查是否需要管理员权限
  if (to.meta.requiresAdmin) {
    try {
      const authResult = await checkAdminAccess()
      if (!authResult.success) {
        console.log('路由守卫：权限检查失败，原因:', authResult.reason)
        if (authResult.redirect) {
          next(authResult.redirect)
        } else {
          next('/')
        }
        return
      }
    } catch (error) {
      console.error('路由守卫：权限检查出错:', error)
      next('/auth')
      return
    }
  }

  // 立即执行路由跳转，不等待任何异步操作
  next();

  // 完全异步的访问记录，使用微任务避免阻塞
  queueMicrotask(() => {
    try {
      // 只记录主要页面，排除特殊页面
      if (to.name !== 'VisitStar' && to.name !== 'Visit' &&
          !to.path.includes('visit') &&
          !to.path.includes('admin')) {

        // 使用火忘模式（fire-and-forget），不等待结果
        wenVisit({
          page: to.fullPath,
          title: to.name || '未知页面',
          from: from.fullPath || '直接访问'
        }).catch(() => {
          // 静默忽略错误，不影响用户体验
        });
      }
    } catch (error) {
      // 静默忽略错误
    }
  });
});

export default router;
